import * as React from "react";
import { FormattedMessage } from "@/i18n/i18n-client";
import {
  FooterFollow,
  TextFollow,
  CloseMenu,
  MobileWrapper,
  MobileNavScrollContainer,
  MobileNavHeader,
  StyledShopButton,
  StyledMyAccountButton,
  StyledLoginButton,
} from "../components/NavBar/styled";
import { Overlay } from "@/shared/globals";
import AccountButton from "../components/NavBar/MobileAccountButton";
import { MobileLanguageSwitcher } from "../components/NavBar/MobileLanguageSwitcher";
import { SocialLinks } from "@/components/UtilityComponents/SocialLinks";
import { CustomerIcon } from "@/assets/Icons/CustomerIcon";
import { LeftArrow } from "@/assets/Icons/LeftArrow";
import MobileMenu from "../components/NavBar/menu/MobileMenu";
import { useAuth } from "@/lib/Authentication/hooks/useAuth";
import { MobileNavigationProps } from "../../types";
import { Link, usePurePathname } from "@/i18n/i18n-navigation";
import { useStore } from "@/lib/storeData/StoreContext";
import { AuthMode } from "@/generated/graphql";
import { useState } from "react";
import CentralizedModal from "@/components/Centralizedlogin/CentralizedModal";

const MobileNavigation = ({
  open,
  onClose,
  socialSettings,
  menus,
}: MobileNavigationProps) => {
  const auth = useAuth();
  const pathname = usePurePathname();
  const { authMode } = useStore();
  const [isActive, setIsActive] = React.useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  React.useEffect(() => {
    if (!auth.isLoggedIn) {
      setIsActive(true);
    }
  }, [auth.isLoggedIn]);

  return (
    <>
      {open && <Overlay onClick={onClose} />}
      <MobileWrapper open={open}>
        <MobileNavScrollContainer>
          <MobileNavHeader
            isFullWidth={pathname === "/login" || pathname === "/registration"}
          >
            <StyledShopButton
              onClick={() => setIsActive(true)}
              className={isActive ? "active" : ""}
              isFullWidth={
                pathname === "/login" || pathname === "/registration"
              }
            >
              <FormattedMessage defaultMessage="Shop" id="Dxd1uB" />
            </StyledShopButton>
            {auth.isLoggedIn ? (
              <StyledMyAccountButton
                onClick={() => setIsActive(false)}
                className={!isActive ? "active" : ""}
              >
                <CustomerIcon />
                <FormattedMessage defaultMessage="My Account" id="2bGejb" />
              </StyledMyAccountButton>
            ) : pathname === "/login" || pathname === "/registration" ? null : (
              <StyledLoginButton>
                {authMode === AuthMode.Modern ? (
                  <div
                    className="flex items-center justify-center"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <CustomerIcon />
                    <FormattedMessage defaultMessage="Login" id="AyGauy" />
                  </div>
                ) : (
                  <Link href="/login">
                    <div className="flex items-center justify-center">
                      <CustomerIcon />
                      <FormattedMessage defaultMessage="Login" id="AyGauy" />
                    </div>
                  </Link>
                )}
              </StyledLoginButton>
            )}
          </MobileNavHeader>
          {isActive ? (
            <>
              <MobileMenu items={menus} />
              <FooterFollow>
                {!socialSettings?.length ? null : (
                  <TextFollow>
                    <FormattedMessage
                      defaultMessage="Follow us on"
                      id="gF/sCa"
                    />
                  </TextFollow>
                )}
                <SocialLinks socialSettings={socialSettings} padding={10} />
              </FooterFollow>
            </>
          ) : (
            <AccountButton />
          )}
          <CloseMenu onClick={onClose}>
            <LeftArrow rotateOnRTL />
          </CloseMenu>
        </MobileNavScrollContainer>
        <MobileLanguageSwitcher />
        <CentralizedModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </MobileWrapper>
    </>
  );
};

export default MobileNavigation;
